import React, { useEffect } from 'react'
import { FaBriefcaseMedical } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import "../../Pages/homepage.css"
export const CategoryCard = ({ icon: FaBriefcaseMedical, label }) => {
  var smallLabel = label.toLowerCase();
  let x=smallLabel.charAt().toUpperCase()
  let y = smallLabel.slice(1);
  x += y;
  // console.log(x)
  return (
    <div className='cat'>
            <Link to={`/fundraise?category=${x}`}>
              <div style={{ marginLeft: '48px', marginTop: '32px' }}>
                  {/* <{icon} size='60px' /> */}
                  <img src="https://ketto.gumlet.io/assets/images/logo-light-bg.svg?w=70&dpr=1.0"  width='40px'alt=""/>
              </div>
              <h1 className='rs-video-head' style={{color: "#fff" }}>{label}</h1>
              <div className='border-d'></div>
              </Link>
    </div>
  )
}
